import { writable, derived } from "svelte/store";

const initialSeconds = 300;

export const secondsLeft = writable(initialSeconds);
export const canResend = derived(secondsLeft, $secondsLeft => $secondsLeft <= 0);

let interval;

export function startConfirmationTimer() {
    clearInterval(interval);
    secondsLeft.set(initialSeconds);

    interval = setInterval(() => {
        secondsLeft.update(sec => {
            if (sec <= 1) {
                clearInterval(interval);
                return 0;
            }
            return sec - 1;
        });
    }, 1000);
}

export function resetConfirmationTimer() {
    secondsLeft.set(initialSeconds);
}

export function stopConfirmationTimer() {
    clearInterval(interval);
}
